import React, { FC } from 'react'

import { ShieldBan } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../../../ui/tooltip'
import { Button } from '../../../../../../ui/button'

import { getUserFullName } from '../../../../../../../helpers/helpers'

import { IUserInterface } from '../../../../../../../models/users/user.interface'

interface RejectedRequestProps {
  user: IUserInterface | null
  size?: 'sm' | 'lg'
}

export const RejectedRequest: FC<RejectedRequestProps> = ({ user, size }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size={size}
          variant="ghost"
          className="p-0 opacity-50 hover:opacity-100 transition-all"
        >
          <ShieldBan className="text-SeabiscuitMainThemeColor" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        The request was rejected {user ? `by ${getUserFullName(user)}` : ''}.
      </TooltipContent>
    </Tooltip>
  )
}
